import Box from "ds/components/Box";
import BadgeNext from "ds/components/BadgeNext";
import { BadgeProps } from "ds/components/BadgeNext/types";

import { CellComponentProps, EntityType } from "../types";

const TYPE_LABELS = {
  [EntityType.User]: "User",
  [EntityType.UserGroup]: "IdP group",
  [EntityType.ApiKey]: "API key",
};

const TYPE_COLORS: Record<EntityType, BadgeProps["variant"]> = {
  [EntityType.User]: "blue",
  [EntityType.UserGroup]: "turquoise",
  [EntityType.ApiKey]: "fuchsia",
};

type RoleUsedByListItemTypeCellProps = CellComponentProps;

const RoleUsedByListItemTypeCell = ({ entity }: RoleUsedByListItemTypeCellProps) => {
  return (
    <Box fullWidth>
      <BadgeNext type="weak" variant={TYPE_COLORS[entity.type]} text={TYPE_LABELS[entity.type]} />
    </Box>
  );
};

export default RoleUsedByListItemTypeCell;
